@if ($model() != null) {
    <form class="px-1" (ngSubmit)="onSubmit()" #flowDefinitionDetails="ngForm">
        <div class="scroll-wrapper styled-scrollbar pr-2">
            <!-- Nome -->
            <ng-container>
                <div class="form-group pl-1" featureHint="flowDefinitionDetails|Name" featureHintHAlign="right" featureHintExclusiveGroup>
                    <label for="name">Nome</label>
                    <input type="text" class="form-control" id="name" name="name" #nameElem="ngModel" maxlength="100" required
                           [ngModel]="$model().name"
                           [disabled]="$isReadOnlyMode()"
                           (input)="nameChange($event.target.value)"
                    >
                </div>
                <div [hidden]="nameElem.valid || nameElem.pristine" class="alert alert-danger">Campo obrigatório (máximo de 100 caracteres)</div>
            </ng-container>

            <!-- Nome Público -->
            <ng-container>
                <div class="form-group pl-1" featureHint="flowDefinitionDetails|PublicName" featureHintHAlign="right" featureHintExclusiveGroup>
                    <label for="publicName">Nome Público</label>
                    <input type="text" class="form-control" id="publicName" name="publicName" #publicNameElem="ngModel" maxlength="100"
                           [ngModel]="$model().publicName"
                           [disabled]="$isReadOnlyMode()"
                           (input)="publicNameChange($event.target.value)"
                    >
                </div>
                <div [hidden]="publicNameElem.valid || publicNameElem.pristine" class="alert alert-danger">Máximo de 100 caracteres</div>
            </ng-container>

            <!-- Caixa de Fluxos -->
            <ng-container>
                <div class="form-group pl-1" featureHint="flowDefinitionDetails|FlowInbox" featureHintHAlign="right">
                    <label for="flowInbox">Caixa de Fluxos</label>

                    <select class="form-control" id="flowInbox" name="flowInbox"
                            [ngModel]="$model().unitId"
                            [disabled]="$isReadOnlyMode()"
                            (change)="flowInboxChange($event.target.value)"
                    >
                        @for (option of getOrderedAdminUnitsList(); track option) {
                            <option [value]="option.guid">
                                @let prefix = option.organizacao?.organizacaoPai?.sigla != null ? option.organizacao.organizacaoPai.sigla + ' - ' : '';
                                {{prefix}}{{option.organizacao?.sigla != null ? option.organizacao.sigla + ' - ' : ''}}{{option.nomeCurto}}
                            </option>
                        }
                    </select>

                    @if (isAdminAll) {
                        <div class="form-group checkbox-group pl-1">
                            <mat-checkbox class="mt-2 ml-0" id="shouldAddFlowInbox" name="shouldAddFlowInbox" color="primary"
                                          [class.mb-2]="$shouldAddFlowInbox()"
                                          [ngModel]="$shouldAddFlowInbox()"
                                          [disabled]="$isReadOnlyMode()"
                                          (change)="$shouldAddFlowInbox.set($event.checked)"
                            >Indicar nova Caixa de Fluxos</mat-checkbox>
                        </div>

                        @if ($shouldAddFlowInbox()) {
                            <edocs-location [_model]="{}"
                                            [_flowDefinitionOrganizationId]="$model().organizationId"
                                            [_isReadOnlyMode]="$isReadOnlyMode()"
                                            [_hideGroup]="true"
                                            [_hideComission]="true"
                                            [_hideSelectOrganization]="true"
                                            [_indentLevel]="4"
                                            (_modelChange)="addFlowInbox($event)"
                            ></edocs-location>
                        }
                    }
                </div>
            </ng-container>

            <!-- Pasta -->
            <ng-container>
                <div class="form-group pl-1" featureHint="flowDefinitionDetails|Directory" featureHintHAlign="right">
                    <label for="flowInboxDirectory">Pasta</label>

                    @if ($flowInboxDirectoryList()?.length > 0) {
                        <select class="form-control" id="flowInboxDirectory" name="flowInboxDirectory"
                                [ngModel]="$model().flowInboxDirectoryId"
                                (change)="flowInboxDirectoryChange($event.target.value)"
                        >
                            <option [value]="null">(na raiz da Caixa de Fluxos)</option>

                            @for (directory of $flowInboxDirectoryList(); track directory.id) {
                                <option [value]="directory.id">
                                    {{ directory.name }}
                                </option>
                            }
                        </select>
                    } @else {
                        <select class="form-control" disabled>
                            <option>(não há pastas na Caixa de Fluxos selecionada)</option>
                        </select>
                    }
                </div>
            </ng-container>

            <!-- Serviço do Catálogo ES -->
            <!-- <ng-container>
                <div class="form-group pl-4" featureHint="flowDefinitionDetails|CatalogService" featureHintHAlign="right">
                    <label for="catalogServiceDisplay">Serviço do Catálogo ES</label>

                    <input type="text" class="form-control info-font searchable" id="catalogServiceDisplay" name="catalogServiceDisplay"
                           [placeholder]="getCatalogServicePlaceholder()"
                           [ngModel]="$catalogServiceDisplay()"
                           [matTooltip]="getCatalogServiceTooltip()"
                           [disabled]="$isReadOnlyMode() || $selectableCatalogServices().length == 0"
                           [matAutocomplete]="catalogServiceAutocomplete"
                           (ngModelChange)="$catalogServiceDisplay.set($event)"
                           (input)="catalogServiceDisplayChange()"
                    >

                    <mat-autocomplete #catalogServiceAutocomplete="matAutocomplete"
                                      [displayWith]="displayCatalogServiceId"
                                      (optionSelected)="catalogServiceIdChange($event)"
                    >
                        @for (option of $selectableCatalogServices(); track option) {
                            <mat-option [value]="option">{{option.description}}</mat-option>
                        }
                    </mat-autocomplete>

                    <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearCatalogService()" (keyDown)="clearCatalogService()"></i>
                </div>
            </ng-container> -->

            <!-- Público-alvo -->
            <ng-container>
                <div class="form-group pl-1" featureHint="flowDefinitionDetails|FlowTarget" featureHintHAlign="right" featureHintShowOn="right">
                    <label for="flowTarget">Público-alvo</label>

                    <select class="form-control" id="flowTarget" name="flowTarget"
                            [ngModel]="$model().targetId"
                            [disabled]="$isReadOnlyMode()"
                            (change)="flowTargetChange($event.target.value)"
                    >
                        @for (option of $flowTargetOptions(); track option.value) {
                            <option [value]="option.value">{{option.description}}</option>
                        }
                    </select>
                </div>
            </ng-container>

            @if ($model().targetId == FlowTarget.Whitelist) {
                <div class="form-group pl-3">
                    <!-- Local do E-Docs -->
                    <edocs-location _organizationLabel="Órgão (selecione como local ou filtre Setores mais abaixo)"
                                    [_model]="$configSchemaSectionEDocsLocation()"
                                    [_flowDefinitionOrganizationId]="$model().organizationId"
                                    [_isReadOnlyMode]="$isReadOnlyMode()"
                                    [_isConditionalForwarding]="true"
                                    [_hideGroup]="true"
                                    [_hideComission]="true"
                                    (_modelChange)="onUpdateEDocsLocation($event)"
                    ></edocs-location>

                    <ng-container>
                        @if ($configSchema().whitelist.length == 0) {
                            <div class="location-container empty mt-4 mb-3 p-2"
                                 featureHint="flowDefinitionDetails|WhitelistLocationPanel" featureHintHAlign="right" featureHintShowOn="right"
                            >
                                <span class="info-font">Nenhum local adicionado</span>
                            </div>
                        } @else {
                            <div class="location-container mt-4 mb-3 p-2"
                                 featureHint="flowDefinitionDetails|WhitelistLocationPanel" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right"
                            >
                                @for (location of $configSchema().whitelist; track location; let i = $index) {
                                    <div class="location p-2">
                                        <pre class="m-0">{{ location.name }}</pre>
                                        <i class="fas fa-trash-alt ml-2" matTooltip="Remover local"
                                           (click)="removeLocation(location)"
                                           (keyDown)="removeLocation(location)"
                                        ></i>
                                    </div>
                                }

                                <button type="button" class="btn btn-outline-danger"
                                        [disabled]="$isReadOnlyMode()"
                                        (click)="removeAllLocations()"
                                        (keyDown)="removeAllLocations()"
                                >
                                    <i class="fas fa-times-circle mr-1"></i>
                                    <span>Remover todos os locais</span>
                                </button>
                            </div>
                        }
                    </ng-container>
                </div>
            }

            <!-- Descrição pública -->
            <ng-container>
                <div class="form-group pl-1" featureHint="flowDefinitionDetails|Description" featureHintHAlign="right" featureHintVAlign="top">
                    <label for="description">Descrição pública</label>

                    @if ($shouldLoadTinyMce()) {
                        <editor name="description" apiKey="no-api-key"
                                [ngModel]="$description()"
                                [init]="tinyMceOptions"
                                [disabled]="$isReadOnlyMode()"
                                (ngModelChange)="$description.set($event)"
                        ></editor>
                    }
                    <textarea id="tinyMceDefinitionDetails" class="d-none"></textarea>
                </div>
            </ng-container>

            <!-- Adicionar informações a títulos do E-Flow -->
            <ng-container>
                <!-- Ativação da opção -->
                <div class="form-group checkbox-group pl-1">
                    <mat-checkbox id="shouldAddInfoToEDocsTitles" name="shouldAddInfoToEDocsTitles" color="primary"
                                  featureHint="flowDefinitionDetails|TitleInfo" featureHintHAlign="right" featureHintShowOn="right"
                                  [ngModel]="$configSchema().shouldAddInfoToEDocsTitles"
                                  [disabled]="$isReadOnlyMode()"
                                  (change)="titleInfoChange($event.checked)"
                    >Adicionar informações a títulos do E-Flow utilizados no E-Docs</mat-checkbox>
                </div>

                <!-- Não adicionar informações a títulos de Documentos capturados -->
                <div class="form-group checkbox-group ml-5">
                    <mat-checkbox id="shouldNotAddInfoToDocuments" name="shouldNotAddInfoToDocuments" color="primary" class="no-additional-info-documents"
                                  [ngModel]="$configSchema().shouldNotAddInfoToDocuments"
                                  [disabled]="!$configSchema().shouldAddInfoToEDocsTitles"
                                  (change)="shouldNotAddInfoToDocumentsChange($event.checked)"
                    >Não adicionar informações a títulos de Documentos capturados</mat-checkbox>
                </div>

                <!-- Seletor de tipo de informação -->
                <mat-radio-group class="title-info-type ml-5" id="titleInfoType" name="titleInfoType" color="primary"
                                 [ngModel]="$titleInfoType()"
                                 [disabled]="$isReadOnlyMode() || !$configSchema().shouldAddInfoToEDocsTitles"
                                 [required]="!$isReadOnlyMode() && $configSchema().shouldAddInfoToEDocsTitles"
                                 (ngModelChange)="titleInfoTypeChange($event)"
                >
                    <mat-radio-button [value]="TitleInfoType.UserName">Nome do usuário instanciador do Fluxo</mat-radio-button>
                    <!--<mat-radio-button [value]="TitleInfoType.UserCpf">CPF do usuário instanciador do Fluxo</mat-radio-button>-->
                    <mat-radio-button [value]="TitleInfoType.FormField">Valor de um campo do formulário</mat-radio-button>
                </mat-radio-group>

                <!-- Campo do formulário -->
                @if ($titleInfoType() == TitleInfoType.FormField) {
                    <div class="d-flex">
                        <div class="form-field-row ml-6">
                            <div class="form-group w-100 px-0">
                                <label for="formField">Campo do Formulário</label>

                                <select class="form-control" id="formField" name="formField"
                                        [ngModel]="$formField()"
                                        [required]="!$isReadOnlyMode() && $configSchema().shouldAddInfoToEDocsTitles && $titleInfoType() == TitleInfoType.FormField"
                                        (change)="$formField.set($event.target.value)"
                                >
                                    @for (option of $formFieldOptions(); track option.value) {
                                        <option [value]="option.value">{{option.description}}</option>
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                }

                <!-- Informação adicional -->
                <div class="form-group checkbox-group ml-5">
                    <mat-checkbox id="shouldAddInfoToEDocsTitles_Additional" name="shouldAddInfoToEDocsTitles_Additional" color="primary" class="additional-info"
                                  [ngModel]="$configSchema().shouldAddInfoToEDocsTitles_Additional"
                                  [disabled]="shouldDisableAdditionalInfo()"
                                  (change)="titleInfoChange_Additional($event.checked)"
                    >Informação adicional</mat-checkbox>
                </div>

                <!-- Seletor de tipo de informação adicional -->
                @if ($configSchema().shouldAddInfoToEDocsTitles_Additional) {
                    <mat-radio-group class="title-info-type ml-6" id="titleInfoType_Additional" name="titleInfoType_Additional" color="primary"
                                     [ngModel]="$titleInfoType_Additional()"
                                     [disabled]="$isReadOnlyMode() || !$configSchema().shouldAddInfoToEDocsTitles_Additional"
                                     [required]="!$isReadOnlyMode() && $configSchema().shouldAddInfoToEDocsTitles_Additional"
                                     (ngModelChange)="titleInfoTypeChange_Additional($event)"
                    >
                        <mat-radio-button [value]="TitleInfoType.UserName">Nome do usuário instanciador do Fluxo</mat-radio-button>
                        <!--<mat-radio-button [value]="TitleInfoType.UserCpf">CPF do usuário instanciador do Fluxo</mat-radio-button>-->
                        <mat-radio-button [value]="TitleInfoType.FormField">Valor de um campo do formulário</mat-radio-button>
                    </mat-radio-group>
                }

                <!-- Campo do formulário -->
                @if ($titleInfoType_Additional() == TitleInfoType.FormField) {
                    <div class="d-flex">
                        <div class="form-field-row ml-7">
                            <div class="form-group w-100 px-0">
                                <label for="formField">Campo do Formulário</label>

                                <select class="form-control" id="formField_Additional" name="formField_Additional"
                                        [ngModel]="$formField_Additional()"
                                        [required]="!$isReadOnlyMode()
                                            && $configSchema().shouldAddInfoToEDocsTitles_Additional
                                            && $titleInfoType_Additional() == TitleInfoType.FormField"
                                        (change)="$formField_Additional.set($event.target.value)"
                                >
                                    @for (option of $formFieldOptions(); track option.value) {
                                        <option [value]="option.value">{{option.description}}</option>
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                }
            </ng-container>

            <!-- Ignorar filtragem de papéis baseada no público-alvo -->
            <ng-container>
                <div class="form-group checkbox-group pl-1" featureHint="flowDefinitionDetails|RoleFiltering" featureHintHAlign="right" featureHintShowOn="right">
                    <mat-checkbox id="shouldIgnoreTargetBasedRoleFiltering" name="shouldIgnoreTargetBasedRoleFiltering" color="primary"
                                  [ngModel]="$configSchema().shouldIgnoreTargetBasedRoleFiltering"
                                  [disabled]="$isReadOnlyMode() || $model().targetId == FlowTarget.Citizen"
                                  (change)="shouldIgnoreTargetBasedRoleFilteringChange($event.checked)"
                    >Ignorar filtragem de papéis baseada no público-alvo</mat-checkbox>
                </div>
            </ng-container>
        </div>

        <!-- Botões -->
        <div class="form-footer text-right mb-1">
            <hr class="mt-0" />

            <!-- ConfigSchema -->
            <button type="button" class="btn btn-outline-secondary float-left ml-1"
                    (click)="showConfigSchema()"
                    (keyDown)="showConfigSchema()"
            >Editar código-fonte</button>

            <!-- Cancelar -->
            <button type="button" class="btn btn-outline-danger mr-2"
                    (click)="closeForm()"
                    (keyDown)="closeForm()"
            >Cancelar</button>

            <!-- Salvar -->
            <button type="submit" class="btn btn-outline-primary"
                    [class.read-only]="$isReadOnlyMode()"
                    [disabled]="!flowDefinitionDetails.form.valid || $isReadOnlyMode()"
            >Salvar Rascunho</button>
        </div>
    </form>

    <!-- Modal do ConfigSchema -->
    <ng-template #configSchemaRef>
        <i class="button fas fa-times close" matTooltip="Fechar" (click)="configSchemaDialog.close()"></i>

        <button type="button" class="button btn btn-primary" (click)="Utils.copyToClipboard(configSchemaEditorRef, copyInfoRef);">
            <i class="fas fa-copy mr-2"></i>
            <span>Copiar conteúdo</span>
        </button>

        <button type="button" class="button btn btn-outline-info info" #copyInfoRef><span>Conteúdo copiado!</span></button>
        <button type="button" class="button btn btn-outline-info info" #pasteInfoRef><span>Conteúdo colado!</span></button>

        <button type="button" class="button btn btn-success right" (click)="Utils.pasteFromClipboard(configSchemaEditorRef, pasteInfoRef)">
            <i class="fas fa-paste mr-2"></i>
            <span>Colar conteúdo</span>
        </button>

        <textarea class="schema-editor form-control styled-scrollbar" [ngModel]="$configSchemaFlat()" #configSchemaEditorRef></textarea>
    </ng-template>
}
